export const CanvasPanel = {
  useGlassmorphism: el => el.getUserSettings('useGlassmorphism'),
  '.useGlassmorphism': {
    theme: 'canvas-card-glass',
  },
  '!useGlassmorphism': {
    theme: 'canvas-card',
  },
  useAnimations: el => el.getUserSettings('useAnimations'),
  '.useAnimations': {
    transition: 'C defaultBezier',
  },
  // Card-outline over live canvas content (design-direction.md §8). Both
  // themes above already carry an opaque/glass fill; DESIGN_LANGUAGE §2.4
  // says explicitly of `canvas-card-glass` that "shadows move to `float`" —
  // applied to both branches for one consistent floating-panel treatment
  // (canvas-card also KEEPS the glass-family shadow rather than reverting to
  // a stroke, since a stroke does no separation work floating content can't
  // already get from elevation).
  shadow: 'float',
};